import React from 'react';
import {
    Typography,
    makeStyles,
    Card,
    CardHeader,
    CardContent
} from '@material-ui/core';
import { CheckCircle } from '@material-ui/icons';
import clsx from 'clsx';
import { cnpjMask } from '../utils';

const useStyles = makeStyles(theme => ({
    card: {
        width: 300,

        [theme.breakpoints.down('xs')]: {
            cursor: 'pointer',
            backgroundColor: theme.palette.action.hover
        }
    },
    card_selecionado: {
        border: '1px solid #d0da00',
        backgroundColor: '#fafae4'
    },
    icon: {
        color: '#d0da00'
    }
}));

function CardEmpresa(
    {
        index,
        selecao,
        empresa,
        handleSelecionarCard
    }
) {
    const classes = useStyles();

    return (
        <Card className={clsx([classes.card], { [classes.card_selecionado]: selecao === index })}
            onClick={() => handleSelecionarCard(index, empresa)}>
            <CardContent>
                {
                    selecao === index &&
                    <CardHeader action={<CheckCircle className={classes.icon} />} />
                }
                <Typography variant='subtitle1'>
                    {empresa.razaoSocial}
                </Typography>
                <Typography variant='body1'>
                    {cnpjMask(empresa.cnpjEmpresa)}
                </Typography>
            </CardContent>
        </Card>
    )
}

export default CardEmpresa;